import { render, staticRenderFns } from "./videoplayer.vue?vue&type=template&id=3a44d3b8&"
import script from "./videoplayer.vue?vue&type=script&lang=js&"
export * from "./videoplayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports